import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_GROWTH_LEGAL_DISCLAIMER_UPDATE = createFcmDetails('growth_legal_disclaimer_update', {
	owner: 'Growth',
	context: 'PSF Membership Ask page',
	description: 'A new disclaimer was added, this FCM stands in place so non US users cannot see untranslated strings',
	import: false,
});
